import type { MutableRefObject } from 'react';

/**
 * Хэлпер предназначен для плавного горизонтального подскролла к элементу в группе элементов.
 * принимает wrapperRef - это контейнер со скроллом и
 * { currentTarget } - event или объект { currentTarget } с элементом, на который кликнули
 */
export const horizontalScrollTabs =
    <T extends { currentTarget: HTMLElement }>(wrapperRef: MutableRefObject<HTMLElement | null>) =>
    ({ currentTarget }: T) => {
        if (!(wrapperRef?.current && currentTarget)) return;

        const { current: wrapperNode } = wrapperRef;
        const { width: wrapperWidth } = wrapperNode.getBoundingClientRect();
        const { width } = currentTarget.getBoundingClientRect();

        wrapperNode.scrollTo({
            left: currentTarget.offsetLeft - wrapperWidth / 2 + width / 2,
            top: 0,
            behavior: 'smooth',
        });
    };
